import { css } from "@emotion/css";
import styled from "@emotion/styled";

export const cardTitleCss = css`
    display: flex;
    align-items: center;
    width: 100%;
`;

export const CardContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    justify-content: center;

    text-align: center;
`;

export const EmptySearchSvg = styled.img`
    width: 300px;
`;
